import React from 'react';

export const useCameraAudioPermission = () => {
  const [errorPermission, setErrorPermission] = React.useState('');
  const [activePermission, setActivePermission] = React.useState(false);
  React.useEffect(() => {
    const checkCameraPermission = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: true,
        });
        if (stream) {
          setActivePermission(true);
        }
      } catch (err) {
        setErrorPermission(
          'Veuillez activer votre caméra et actualiser votre page',
        );
      }
    };

    checkCameraPermission();
  }, []);
  return { errorPermission, activePermission };
};
